<template>
    <v-container fluid>
        <v-btn
            :loading="customerimportjobs === null"
            @click="newCustomerImportJob"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Customer Import Jobs ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <!--
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
        -->
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="customerimportjobs === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="customerimportjob.id"
                    cols="12"
                    v-for="customerimportjob in customerimportjobs"
                >
                    <!--@click="loadCustomerImportJobForm(customerimportjob.entity)"-->
                    <v-card
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title>
                            <h5>#{{ customerimportjob.id }} Job</h5>
                        </v-card-title>
                        <v-card-subtitle>{{
                            customerimportjob.createdAt
                        }}</v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col cols="4">
                                    <v-select
                                        disabled
                                        :items="sureReps"
                                        item-text="value"
                                        item-value="key"
                                        label="Signed By"
                                        v-model="
                                            customerimportjob.userAccisureRepId
                                        "
                                    ></v-select
                                ></v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-select
                                        disabled
                                        :items="companies"
                                        item-text="value"
                                        item-value="key"
                                        label="Company"
                                        v-model="
                                            customerimportjob.customerCompanyId
                                        "
                                    ></v-select
                                ></v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-select
                                        disabled
                                        :items="representatives"
                                        item-text="value"
                                        item-value="key"
                                        label="Representative"
                                        v-model="
                                            customerimportjob.representativeId
                                        "
                                    ></v-select
                                ></v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-select
                                        disabled
                                        :items="subscriptions"
                                        item-text="value"
                                        item-value="key"
                                        label="Subscription"
                                        v-model="
                                            customerimportjob.subscriptionId
                                        "
                                    ></v-select
                                ></v-col>
                                <v-col cols="12"></v-col>
                                <v-col cols="3"
                                    ><v-btn
                                        color="secondary"
                                        @click.stop="
                                            getFile(
                                                customerimportjob.importFileId,
                                                'customerimportjob_' +
                                                    customerimportjob.id +
                                                    '_importfile'
                                            )
                                        "
                                        >Import File</v-btn
                                    ></v-col
                                >
                                <v-col cols="3"
                                    ><v-btn
                                        v-show="
                                            customerimportjob.customerDepenIsSuccess ===
                                                false ||
                                            customerimportjob.customerIsSuccess ===
                                                false ||
                                            customerimportjob.identityIsSuccess ===
                                                false ||
                                            customerimportjob.parseIsSuccess ===
                                                false
                                        "
                                        color="orange"
                                        @click.stop="
                                            loadCusttomerImportJobResetForm(
                                                customerimportjob.id
                                            )
                                        "
                                        >Reset job with new file</v-btn
                                    ></v-col
                                >
                            </v-row>
                        </v-card-text>
                        <v-card-text>
                            <v-row>
                                <v-col
                                    cols="6"
                                    md="3"
                                    ><v-card elevation="4">
                                        <v-card-subtitle
                                            class="font-weight-bold"
                                            >File</v-card-subtitle
                                        >
                                        <v-card-text
                                            >Status:
                                            <v-icon
                                                v-if="
                                                    customerimportjob.parseIsSuccess ===
                                                    false
                                                "
                                                color="red"
                                                >mdi-alert-circle-outline</v-icon
                                            >
                                            <v-icon
                                                v-else-if="
                                                    customerimportjob.parseIsSuccess ===
                                                    true
                                                "
                                                color="green"
                                                >mdi-check</v-icon
                                            >
                                            <span v-else>N/A</span>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn
                                                color="secondary"
                                                :disabled="
                                                    !(
                                                        customerimportjob.parseIsSuccess ===
                                                            true ||
                                                        customerimportjob.parseIsSuccess ===
                                                            false
                                                    )
                                                "
                                                @click.stop="
                                                    getFile(
                                                        customerimportjob.parseResultFileId,
                                                        'customerimportjob_' +
                                                            customerimportjob.id +
                                                            '_parseresult'
                                                    )
                                                "
                                                >Result File</v-btn
                                            ></v-card-actions
                                        >
                                    </v-card></v-col
                                >
                                <v-col
                                    cols="6"
                                    md="3"
                                    ><v-card elevation="4">
                                        <v-card-subtitle
                                            class="font-weight-bold"
                                            >Identity</v-card-subtitle
                                        >
                                        <v-card-text
                                            >Status:
                                            <v-icon
                                                v-if="
                                                    customerimportjob.identityIsSuccess ===
                                                    false
                                                "
                                                color="red"
                                                >mdi-alert-circle-outline</v-icon
                                            >
                                            <v-icon
                                                v-else-if="
                                                    customerimportjob.identityIsSuccess ===
                                                    true
                                                "
                                                color="green"
                                                >mdi-check</v-icon
                                            >
                                            <span v-else>N/A</span>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn
                                                :disabled="
                                                    !(
                                                        customerimportjob.identityIsSuccess ===
                                                            true ||
                                                        customerimportjob.identityIsSuccess ===
                                                            false
                                                    )
                                                "
                                                color="secondary"
                                                @click.stop="
                                                    getFile(
                                                        customerimportjob.identityResultFileId,
                                                        'customerimportjob_' +
                                                            customerimportjob.id +
                                                            '_identityresult'
                                                    )
                                                "
                                                >Result File</v-btn
                                            ></v-card-actions
                                        >
                                    </v-card></v-col
                                >
                                <v-col
                                    cols="6"
                                    md="3"
                                    ><v-card elevation="4">
                                        <v-card-subtitle
                                            class="font-weight-bold"
                                            >Customer</v-card-subtitle
                                        >
                                        <v-card-text
                                            >Status:
                                            <v-icon
                                                v-if="
                                                    customerimportjob.customerIsSuccess ===
                                                    false
                                                "
                                                color="red"
                                                >mdi-alert-circle-outline</v-icon
                                            >
                                            <v-icon
                                                v-else-if="
                                                    customerimportjob.customerIsSuccess ===
                                                    true
                                                "
                                                color="green"
                                                >mdi-check</v-icon
                                            >
                                            <span v-else>N/A</span>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn
                                                color="secondary"
                                                :disabled="
                                                    !(
                                                        customerimportjob.customerIsSuccess ===
                                                            true ||
                                                        customerimportjob.customerIsSuccess ===
                                                            false
                                                    )
                                                "
                                                @click.stop="
                                                    getFile(
                                                        customerimportjob.customerResultFileId,
                                                        'customerimportjob_' +
                                                            customerimportjob.id +
                                                            '_customerresult'
                                                    )
                                                "
                                                >Result File</v-btn
                                            ></v-card-actions
                                        >
                                    </v-card></v-col
                                >
                                <v-col
                                    cols="6"
                                    md="3"
                                    ><v-card elevation="4">
                                        <v-card-subtitle
                                            class="font-weight-bold"
                                            >Dependent</v-card-subtitle
                                        >
                                        <v-card-text>
                                            Status:
                                            <v-icon
                                                v-if="
                                                    customerimportjob.customerDepenIsSuccess ===
                                                    false
                                                "
                                                color="red"
                                                >mdi-alert-circle-outline</v-icon
                                            >
                                            <v-icon
                                                v-else-if="
                                                    customerimportjob.customerDepenIsSuccess ===
                                                    true
                                                "
                                                color="green"
                                                >mdi-check</v-icon
                                            >
                                            <span v-else>N/A</span>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn
                                                color="secondary"
                                                :disabled="
                                                    !(
                                                        customerimportjob.customerDepenIsSuccess ===
                                                            true ||
                                                        customerimportjob.customerDepenIsSuccess ===
                                                            false
                                                    )
                                                "
                                                @click.stop="
                                                    getFile(
                                                        customerimportjob.customerDepenResultFileId,
                                                        'customerimportjob_' +
                                                            customerimportjob.id +
                                                            '_customerdependentresult'
                                                    )
                                                "
                                                >Result File</v-btn
                                            ></v-card-actions
                                        >
                                    </v-card></v-col
                                >
                            </v-row>
                        </v-card-text>
                        <v-card-actions v-if="customerimportjob.customerDepenIsSuccess === true">
                            <v-btn
                                :loading="customerimportjob._sendingWhatsApp"
                                color="green darken-1"
                                dark
                                @click.stop="sendWhatsAppToNewCustomers(customerimportjob)"
                            >Send WhatsApp to new customers</v-btn>
                        </v-card-actions>
                        <!--<v-card-text class="pt-0">Customers: {{providerGroupWithInfo.info.customerCount}}</v-card-text>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            persistent
            v-model="customerimportjobFormVisible"
            width="500px"
        >
            <CustomerImportJobForm
                :key="customerimportjobFormKey"
                @close="closeCustomerImportJobForm"
            />
        </v-dialog>

        <v-dialog
            persistent
            v-model="customerimportjobResetFormVisible"
            width="500px"
        >
            <CustomerImportJobResetForm
                :key="resestId"
                :entity-id="resetId"
                @close="closeCustomerImportJobResetForm"
            />
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import CustomerImportJob from "../models/CustomerImportJob.model";
import uuid4 from "../helpers/uuid4";
import CustomerImportJobForm from "../components/forms/CustomerImportJobForm";
import CustomerImportJobResetForm from "../components/forms/CustomerImportJobResetForm";

export default {
    name: "CustomerImportJobs",
    props: ["status"],
    data: function () {
        return {
            //main data
            customerimportjobs: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),
            sureReps: [],
            representatives: [],
            subscriptions: [],
            debitOrderDates: [],
            companies: [],
            refreshTimeout: null,
            refreshMiliSeconds: 30000,

            //form
            customerimportjobFormVisible: false,
            customerimportjobFormKey: 0,

            customerimportjobResetFormVisible: false,
            resetId: 0,
        };
    },
    created: async function () {
        this.sureReps = await this.$store.dispatch("users/getAccisureReps");
        this.representatives = await this.$store.dispatch(
            "representatives/getlist"
        );
        this.subscriptions = await this.$store.dispatch(
            "subscriptions/getlist"
        );
        this.debitOrderDates = await this.$store.dispatch(
            "customers/getDebitOrderDates"
        );
        this.companies = await this.$store.dispatch("companies/getlist");
    },
    mounted: function () {
        this.getCustomerImportJobs();
    },
    destroyed: function () {
        this.stopRefreshTimeOut();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        CustomerImportJobForm,
        CustomerImportJobResetForm,
        //
    },
    methods: {
        stopRefreshTimeOut() {
            if (this.refreshTimeout != null) clearTimeout(this.refreshTimeout);
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix,
            });
        },
        async getCustomerImportJobs() {
            this.stopRefreshTimeOut();

            this.$store
                .dispatch("customerimportjobs/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                    },
                    requestId: this.requestId,
                })
                .then((customerimportjobsResponse) => {
                    if (
                        this.requestId == customerimportjobsResponse.requestId
                    ) {
                        this.customerimportjobs = null;
                        this.customerimportjobs =
                            customerimportjobsResponse.data.page;
                        this.totalMatches =
                            customerimportjobsResponse.data.total;
                        this.pageSize =
                            customerimportjobsResponse.data.pageSize;
                        this.pageNo =
                            customerimportjobsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            customerimportjobsResponse.data.total /
                                this.pageSize
                        );
                    }
                })
                .finally(() => {
                    this.refreshTimeout = setTimeout(
                        this.getCustomerImportJobs,
                        this.refreshMiliSeconds
                    );
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.customerimportjobs !== null)
                this.customerimportjobs = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getCustomerImportJobs,
                debounceTime
            );
        },

        sendWhatsAppToNewCustomers(job) {
            this.$set(job, '_sendingWhatsApp', true);
            this.$store
                .dispatch("customerimportjobs/sendWhatsAppToNewCustomers", job.id)
                .then(() => {
                    alert("WhatsApp messages sent to new customers.");
                })
                .catch(() => {
                    alert("Failed to send WhatsApp messages.");
                })
                .finally(() => {
                    this.$set(job, '_sendingWhatsApp', false);
                });
        },
        //FORM METHODS---------------------------------
        newCustomerImportJob() {
            this.loadCustomerImportJobForm();
        },
        loadCustomerImportJobForm() {
            this.customerimportjobFormKey += 1;
            this.customerimportjobFormVisible = true;
        },
        closeCustomerImportJobForm() {
            this.customerimportjobFormVisible = false;
            this.paginationDebounce(0);
        },
        loadCusttomerImportJobResetForm(toResetId) {
            this.resetId = toResetId;
            this.customerimportjobResetFormVisible = true;
        },
        closeCustomerImportJobResetForm() {
            this.customerimportjobResetFormVisible = false;
            this.paginationDebounce(0);
        },
    },
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
